import BelatedPortingModule from './belatedPorting.js'
import ActivationModule from './activation.js'
import OrderingModule from './ordering.js'
import SubstituteSimModule from './substituteSim.js'

const CheckoutV2Module = {
  namespaced: true,
  modules: {
    activation: ActivationModule,
    belatedPorting: BelatedPortingModule,
    substituteSim: SubstituteSimModule,
    ordering: OrderingModule
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {}
}

export default CheckoutV2Module
